import { useLang } from 'hooks/lang';

import {
  IconButton,
  Column,
  Row,
  ResponsiveOverlay,
  Button,
  overlayEscape,
  Label,
  ShortcutTag,
} from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';
import { LogoutIcon } from 'components/Icons';

import { CreateBugReportModal } from 'pages/Feedback/components';
import { SecondaryTeamSelect } from './SecondaryTeamSelect';

import { useAuth } from 'providers/Auth';
import { getFirstAndLastName } from 'utils/text';
import { useMultiKeyPress } from 'hooks';

export function UserMenu() {
  const {
    signOut,
    user: { data },
  } = useAuth();

  const { t } = useLang();

  const logoutKeys = useMultiKeyPress({
    key: 'L',
    triggerKey: ['ctrl', 'shift'],
    action: () => signOut(),
  });

  return (
    <ResponsiveOverlay
      default="pop-over"
      gap="0"
      trigger={
        <IconButton size="fit">
          <UserAvatar user={data} showNameOnHover={false} size={36} />
        </IconButton>
      }
    >
      <Row justifyContent="space-between">
        <Column gap="0">
          <p>{getFirstAndLastName(data.name)}</p>

          <p className="text-xs">{data.team.name}</p>
        </Column>

        <UserAvatar user={data} showNameOnHover={false} />
      </Row>

      <hr className="my-4" />

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        to="profile"
        onClick={() => overlayEscape()}
      >
        {t('profile')}
      </Button>

      {!!data.isSysAdmin && data.type === 'LEADER' ? (
        <Button
          variant="ghost"
          className="justify-start font-normal text-inherit hover:text-primary"
          to="teams"
          onClick={() => overlayEscape()}
        >
          {t('team')}
        </Button>
      ) : (
        <Button
          variant="ghost"
          className="justify-start font-normal text-inherit hover:text-primary"
          to="teamProfile"
          onClick={() => overlayEscape()}
          params={{ teamId: data.team.id }}
        >
          {t('team')}
        </Button>
      )}

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        to="offices"
        onClick={() => overlayEscape()}
      >
        {t('offices')}
      </Button>

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        to="outsourceProviders"
        onClick={() => overlayEscape()}
      >
        {t('outsource-providers')}
      </Button>

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        to="clients"
        onClick={() => overlayEscape()}
      >
        {t('clients')}
      </Button>

      <SecondaryTeamSelect />

      <Label className="my-1.5 text-xs font-semibold">Feedback</Label>

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        to="userSuggestions"
        onClick={() => overlayEscape()}
      >
        {t('suggestions')}
      </Button>

      {data?.isSysAdmin ? (
        <Button
          variant="ghost"
          className="justify-start font-normal text-inherit hover:text-primary"
          to="bugReports"
          onClick={() => overlayEscape()}
        >
          {t('bug-reports')}
        </Button>
      ) : (
        <CreateBugReportModal
          trigger={
            <Button
              variant="ghost"
              className="justify-start font-normal text-inherit hover:text-primary"
            >
              {t('bug-report')}
            </Button>
          }
        />
      )}

      <hr className="my-2 text-inherit hover:text-primary" />

      <Button
        variant="ghost"
        className="justify-start font-normal text-inherit hover:text-primary"
        onClick={() => signOut()}
      >
        <LogoutIcon />
        {t('logout')}

        <ShortcutTag keys={logoutKeys} joiner="" className="text-xxs" />
      </Button>
    </ResponsiveOverlay>
  );
}
